import ApiService from "@/core/services/api.service";

//Actions
export const FETCH_CUSTOMERS_BASIC = "fetchCustomersBasic";

//Mutations
export const SET_LOADING = "setLoadingSharedCustomer";

const state = {
  isLoadingSharedCustomer: false
};

const getters = {
  isLoadingSharedCustomer() {
    return state.isLoadingSharedCustomer;
  }
};

const actions = {
  [FETCH_CUSTOMERS_BASIC](context, apiParams = "") {
    context.commit(SET_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiService.get("customers-basic" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_LOADING](state, value) {
    state.isLoadingSharedCustomer = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
